.card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-sm);
  min-width: 0;
}
.p-none {
  padding: 0;
}
.p-md {
  padding: var(--space-5);
}
.p-lg {
  padding: var(--space-8);
}
.dark {
  background: var(--navy);
  color: #e6eaf0;
  border-color: #1e2a3d;
}
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-3);
  margin-block-end: var(--space-4);
}
.headerText {
  /* Le texte garde une largeur lisible ; les actions passent dessous si la place manque. */
  flex: 1 1 260px;
  min-width: 0;
}
.title {
  font-size: var(--text-lg);
  font-weight: 700;
}
.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  margin-block-start: 2px;
}
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  flex: 0 1 auto;
  max-width: 100%;
}
